<template>
    <tabs-section
        class="c-field_videos"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"
        :title="title"
        :saved="value !== null"
        @history="openHistory"
        @next="save">

        <visit-history-previous
            v-if="lastVisit !== null && lastValueExist"
            @copy="copyValue">
            <a
                class="c-field_videos__last_value"
                v-for="(video, index) in lastValue"
                :key="index"
                :href="video"
                target="_blank">
                {{ video }}
            </a>
        </visit-history-previous>

        <form-videos
            :label="label"
            :name="name"
            v-model="newValue">
        </form-videos>

        <visit-history-modal ref="videosHistoryModal" :title="title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_text__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                <ul v-if="item.value.length" class="c-field_videos__history-list">
                    <form-video
                        v-for="(video, index) in item.value"
                        :key="index"
                        :url="video">
                    </form-video>
                </ul>
                <p v-else>Brak filmów</p>
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>
</template>


<script>

import {mapGetters} from 'vuex'
import {FormVideos, FormVideo} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'

import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'
import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'

import noReact from 'Utils/NoReact'

export default {

    name: 'VisitFieldVideos',

    props: {
        value: Array,
        name: String,
        label: String,
        title: String
    },

    data() {
        return {
            fieldHistory: [],
            newValue: noReact(this.value) || [],
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit']),
        lastValueExist() {
            return typeof this.lastVisit[this.name] !== 'undefined'
                && this.lastVisit[this.name] !== null
                && this.lastVisit[this.name].length > 0
        },
        lastValue() {
            return this.lastVisit[this.name]
        },
        nextLabel() {
            if (!this.isEdited || (this.value === null && this.newValue.length === 0))
                return 'Dalej'
            return 'Zapisz'
        },
        isEdited() {
            return !this.newValue.compare(this.value)
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: this.newValue,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 1000)
                nextSection()
            }).catch((error) => {
                this.$alert.error('Przebieg wizyty', error.response.data.message)
                nextSection(false)
            })
        },
        openHistory() {
            this.$refs.videosHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = history
        },
        copyValue() {
            this.newValue = Array.from(new Set(this.newValue.concat(this.lastVisit[this.name])))
        }
    },

    watch: {
        value(value) {
            this.newValue = value
        }
    },

    components: {
        FormVideos,
        FormVideo,
        TabsSection,
        VisitHistoryModal,
        VisitHistoryItem,
        VisitHistoryPrevious
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-field_videos {
    &__history {
        &-list {
            margin: 1rem -0.3rem;
            display: flex;
            flex-wrap: wrap;
        }
    }
    &__last_value {
        display: block;
        color: $c-text;
        text-decoration: underline;
    }
}

</style>

